export default class UserAccountService {
  // Note: Some of these API calls require you to be authenticated first and some do not.
  unsecuredBaseUrl = '/aptitude/noauth/api/useraccount/';
  securedBaseUrl = '/aptitude/api/useraccount/';

  constructor(private $http) {
    'ngInject';
  }

  changePassword(
    email: string,
    oldPassword: string,
    newPassword: string
  ): ng.IPromise<any> {
    return this.$http.post(
      `${this.unsecuredBaseUrl}changepasswordrequests`,
      {
        email,
        oldPassword,
        newPassword
      },
      {
        intercept: true
      }
    );
  }

  /**
   * Call this for authenticated users to reset the password
   */
  authenticatedResetPassword(email: string) {
    return this.$http.post('/aptitude/api/useraccount/passwordresetrequests/', {
      email: email
    });
  }

  passwordresetrequests(
    email: string,
    recaptchaResponse: string
  ): ng.IPromise<any> {
    return this.$http.post(`${this.unsecuredBaseUrl}passwordresetrequests`, {
      email,
      recaptchaResponse
    });
  }

  // This function is the companion to the one above, it is used to actually change the password for a user.
  resetpasswordrequests(
    securityCode: string,
    newPassword: string
  ): ng.IPromise<any> {
    return this.$http.post(`${this.unsecuredBaseUrl}resetpasswordrequests`, {
      securityCode,
      newPassword
    });
  }

  securitycodes(securityCode: string): ng.IPromise<any> {
    return this.$http.get(`${this.unsecuredBaseUrl}securitycodes`, {
      params: {
        securityCode
      }
    });
  }

  termsandconditionsrequests(acceptTermsAndConditions: boolean) {
    return this.$http.post(`${this.securedBaseUrl}termsandconditionsrequests`, {
      acceptTermsAndConditions
    });
  }
}
